var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraph1Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9362_122239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.16C21.5 5.96 21.42 5.77 21.28 5.63L15.87 0.22C15.73 0.08 15.54 0 15.34 0H3.75C2.79 0 2 0.79 2 1.75V21.75C2 22.71 2.79 23.5 3.75 23.5H19.75C20.71 23.5 21.5 22.71 21.5 21.75V6.16ZM20 21.25C20 21.66 19.66 22 19.25 22H4.25C3.84 22 3.5 21.66 3.5 21.25V2.25C3.5 1.84 3.84 1.5 4.25 1.5H14.71C14.91 1.5 15.1 1.58 15.24 1.72L19.78 6.26C19.92 6.4 20 6.59 20 6.79V21.26V21.25Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4698 9.28001C16.7498 8.99001 16.7498 8.51001 16.4498 8.22001C16.1598 7.94001 15.6998 7.94001 15.4098 8.22001L12.9098 10.72C12.7498 10.88 12.4998 10.91 12.3098 10.8L10.6398 9.80001C10.5198 9.73001 10.3898 9.69001 10.2498 9.69001C10.0598 9.69001 9.85975 9.77001 9.71975 9.91001L6.44975 13.18C6.16975 13.47 6.16975 13.95 6.46975 14.24C6.75975 14.52 7.21975 14.52 7.50975 14.24L10.0798 11.67C10.2398 11.51 10.4898 11.48 10.6798 11.59L12.3498 12.59C12.6398 12.77 13.0198 12.72 13.2698 12.48L16.4698 9.29001V9.28001Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.4399H6.75C6.34 16.4399 6 16.7799 6 17.1899C6 17.5999 6.34 17.9399 6.75 17.9399H16.5C16.91 17.9399 17.25 17.5999 17.25 17.1899C17.25 16.7799 16.91 16.4399 16.5 16.4399Z",
    stroke: "none",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9362_122239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 23.5,
    fill: "white",
    transform: "translate(2)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph1Regular);
export default __webpack_public_path__ + "static/media/graph1-regular.c17d277df920bb4762f1fd174bfc6e04.svg";
export { ForwardRef as ReactComponent };